import { sortProfilesByLocation } from "../../utils/utils";
import {
  MENU_ITEM_TRANSLATIONS,
  MENU_ITEMS_CREATE_PRODUCT_PROFILES,
  MENU_ITEMS_FETCH_PRODUCT_PROFILES,
  MENU_ITEMS_REMOVE_PRODUCT_PROFILES,
  MENU_ITEMS_UPDATE_PRODUCT_PROFILES
} from "../action-types/menu-items-types";

const initialState = {
  profiles: [],
  profileToEdit: {},
  loading: false,
  menuItemTranslations: [],
  error: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case MENU_ITEMS_FETCH_PRODUCT_PROFILES.REQUEST:
    case MENU_ITEMS_CREATE_PRODUCT_PROFILES.REQUEST:
    case MENU_ITEMS_REMOVE_PRODUCT_PROFILES.REQUEST:
    case MENU_ITEMS_UPDATE_PRODUCT_PROFILES.REQUEST:
    case MENU_ITEM_TRANSLATIONS.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case MENU_ITEMS_FETCH_PRODUCT_PROFILES.REJECTED:
      return {
        ...state,
        loading: false,
      };
    case MENU_ITEMS_FETCH_PRODUCT_PROFILES.SUCCESS:
      return {
        ...state,
        loading: false,
        menuItem: action.payload.data.menuItem,
        profiles: sortProfilesByLocation(action.payload.data.productProfiles),
      };
    case MENU_ITEM_TRANSLATIONS.SUCCESS:
      return {
        ...state,
        menuItemTranslations: action.payload.data?.translations,
        loading: false,
      };
    case MENU_ITEM_TRANSLATIONS.REJECTED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
